<a
    [placement]="placement"
    [ngbTooltip]="message"
    class="material-icons text-info text-decoration-none"
    [ngClass]="size === 'small' ? 'icon-small' : 'icon-default'">
    help
</a>
